import { createSelector } from 'reselect'

export const getError = createSelector(
  state => state && state.ads && state.ads.add && state.ads.add.error ? state.ads.add.error : null,
  error => error
)
